import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { handlePhotoUpload } from "../../filestackRequestViaApi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppraisalData,
  selectAppraisal,
  getRequiredPhotoData
} from "../../../../store/selectors";
import { imageUploadSlice } from "../../../../store/slices/ImageUploads";
import MilageOnlyUpload from "./MilageOnlyUpload";
import { useDispatch as useAxiosDispatch } from "../../context/axiosContext";

export default function MilageOnlyUploadContainer() {
  const id = "mileage";
  const requiredPhotoData = useSelector(getRequiredPhotoData);
  const { images: savedImages } = useSelector(getAppraisalData);
  const {
    data: { appraisalSessionId }
  } = useSelector(selectAppraisal);
  const navigate = useNavigate();
  const axiosDispatch = useAxiosDispatch();

  const [currentHelper, setCurrentHelper] = useState(null);

  const dispatch = useDispatch();

  // handles back nav without saving image
  useEffect(() => {
    dispatch(imageUploadSlice.actions.clearUnSavedImages(savedImages));
    dispatch(imageUploadSlice.actions.clearCurrentImageIdentifiers());
  }, [dispatch, savedImages]);

  useEffect(() => {
    dispatch(imageUploadSlice.actions.clearCurrentUploads());
    dispatch(imageUploadSlice.actions.setMaxUploads(10));
  }, [dispatch]);

  useEffect(() => {
    const currentHelper = requiredPhotoData.find((data) => data.id === id);
    dispatch(imageUploadSlice.actions.setCurrentUploadHelper(currentHelper));
    setCurrentHelper(currentHelper);
  }, [dispatch, id, requiredPhotoData]);

  const handleChange = async (images) => {
    if (images) {
      navigate(`/milage-upload-progress`);
      handlePhotoUpload(
        images,
        dispatch,
        currentHelper,
        axiosDispatch,
        appraisalSessionId
      );
    }
  };

  return (
    <>
      {currentHelper && (
        <MilageOnlyUpload
          currentHelper={currentHelper}
          handleChange={handleChange}
        />
      )}
    </>
  );
}

MilageOnlyUploadContainer.propTypes = {
  id: PropTypes.string
};
